module.exports = __webpack_public_path__ + "img/NoAgent-en.1e6379c.png";